import { format, isSameDay } from 'date-fns'
import {
  type AppDateLocale,
  appDateLocale,
  dateFnsLocale,
  formatLongDate,
} from '~/shared/lib/date-locale'

function clockPattern(locale: AppDateLocale) {
  return locale === 'de' ? 'H:mm' : 'h:mm a'
}

/** "18. Oktober 2026" / "October 18th, 2026". */
export function formatEventDay(date: Date, locale = appDateLocale()): string {
  return formatLongDate(date, locale)
}

/** "Sonntag, 18. Oktober 2026" / "Sunday, October 18th, 2026". */
export function formatEventLongDay(date: Date, locale = appDateLocale()): string {
  return format(date, 'PPPP', { locale: dateFnsLocale(locale) })
}

/** "So., 18.10.2026" / "Sun, Oct 18, 2026". */
export function formatEventShortDay(date: Date, locale = appDateLocale()): string {
  return format(date, locale === 'de' ? 'EEEEEE., P' : 'EEE, PP', {
    locale: dateFnsLocale(locale),
  })
}

/** "9:00" / "9:00 AM". */
export function formatEventClock(date: Date, locale = appDateLocale()): string {
  return format(date, clockPattern(locale), { locale: dateFnsLocale(locale) })
}

/** "9:00–18:00"; an end on another day carries its own short date. */
export function formatEventTimeRange(start: Date, end: Date, locale = appDateLocale()): string {
  if (isSameDay(start, end)) {
    return `${formatEventClock(start, locale)}–${formatEventClock(end, locale)}`
  }
  return `${formatEventClock(start, locale)} – ${formatEventShortDay(end, locale)} ${formatEventClock(end, locale)}`
}
